<h3 mat-dialog-title>
    <img src="assets/Thomas.png" width="40px" class="me-3  rounded-circle" /><b>Thomas</b> de LyBox<br/>
</h3>
<div mat-dialog-content>
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
    Bonjour {{ authenticationService.currentUser.firstname}}, parlez-nous de votre projet !<br/>
    <br/>
    Vous avez essayé Lybox et vous souhaitez nous parler d'amélioration ? <br/>
    Vous avez des questions concernant vos projets immobiliers ? <br/>
    <br/>
    <b>Réservez un moment avec nous !</b><br/>
    <br/>
    30 minutes avec l'un des cofondateurs pour répondre à vos interrogations.<br/>
    <br/>
    <b>Comment ?</b><br/>
    Cliquez sur le lien ci-dessous et réservez un créneau avec nous.
    <br/>
    <br/>
    <div class="text-center">
        <a (click)="onNoClick()" class="me-5 cursor-pointer">Non merci</a>
        <a href="{{ link }}" (click)="onYesClick()" target="_blank" type="button" class="btn btn-primary">
            <i class="fa fa-play me-3" aria-hidden="true"></i> Reserver un appel
        </a>
    </div>
</div>
